export default "__VITE_ASSET__f2854c12__"